import { AvailabilityBucketRepository } from "@/repositories/availability-bucket-repository"
import { type IAvailabilityBucket } from "@/interfaces/api/availability-bucket.interface.ts"
import { AvailabilityBucket } from "@/models/availability-bucket.model.ts"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export class AvailabilityBucketController extends GenericModelController<
  AvailabilityBucket,
  IAvailabilityBucket,
  AvailabilityBucketRepository
> {
  constructor() {
    super(AvailabilityBucket, {}, new AvailabilityBucketRepository())
  }
}
